// @ts-check
import { LitElement, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import { getText } from '@utils/i18n.js';

import { globalStyles } from '@styles/vst-style-global.css.js';
import { vstUiLicenseInfoStyles } from './vst-ui-license-info.css.js';

export class VstUiLicenseInfo extends LitElement {
  /** @override */
  static get properties() {
    return {
      // #region private state reactive properties
      // #endregion

      // #region public reactive properties
      licenseExpiration: { type: String },
      licenseExpired: { type: Boolean },
      licenseName: { type: String },
      // #endregion
    };
  }

  /** @override */
  static get styles() {
    return [globalStyles, vstUiLicenseInfoStyles];
  }

  constructor() {
    super();
    this.licenseExpiration = '';
    this.licenseExpired = false;
    this.licenseName = '';
  }

  // #region Lit Lifecycle Callbacks
  // #endregion

  // #region getters/setters
  // #endregion

  // #region private methods
  // #endregion

  // #region public methods
  // #endregion

  // #region template methods
  // #endregion

  /** @override */
  render() {
    return html`
      <div id="license-info" class="inline ${classMap({ expired: this.licenseExpired })}">
        <p class="license-name">
          <label class="heading" size="s">${getText('Licensed To')}:</label>
          ${this.licenseName}
        </p>
        <p>
          <label class="heading" size="s">
            ${this.licenseExpired ? getText('Subscription Ended') : getText('Subscription Ends')}:
          </label>
          ${this.licenseExpiration}
        </p>
      </div>
    `;
  }
}

customElements.define('vst-ui-license-info', VstUiLicenseInfo);
